import { memo } from 'react';
import View from '@picsart/view/View';
import Text from '@picsart/text/Text';
import { useTranslator } from '@picsart/rc/services/localization';
import { FontWeights, Spacings, Typography } from '@picsart/cascade';
import { IllustrationUploadCloudStorage } from '@picsart/illustrations';

import { ALLOWED_LIMIT_FILES } from 'pages/Batch/configs';
import useBatchData from 'pages/Batch/sections/Context/useBatchData';

const DropImage = () => {
  const translate = useTranslator();
  const { isWeb } = useBatchData();

  return (
    <View flexDirection="column">
      <View flexDirection="row" justifyContent="center" alignItems="center">
        <IllustrationUploadCloudStorage width={90} height={90} />
      </View>
      <View marginBlock={Spacings.s8}>
        <Text weight={FontWeights.SemiBold} size={Typography.t5}>
          {translate(isWeb ? `Drag up to ${ALLOWED_LIMIT_FILES} images to upload` : `Upload up to ${ALLOWED_LIMIT_FILES} images`)}
        </Text>
      </View>
      <View flexDirection="row" justifyContent="center" alignItems="center">
        <Text size={Typography.t3} weight={FontWeights.Regular}>JPG, JPEG, PNG or WEBP</Text>
      </View>
    </View>
  );
};

export default memo(DropImage);
